/**
 * Application Constants
 *
 * Centralized constants to avoid magic numbers throughout the codebase.
 * These values are used for polling intervals, thresholds, and limits.
 */

// ============================================
// Polling Intervals (milliseconds)
// ============================================

/** Balance refetch interval for wallet hook (30 seconds) */
export const BALANCE_REFETCH_INTERVAL_MS = 30000;

/** Queue statistics refresh interval (15 seconds) */
export const QUEUE_STATS_REFRESH_INTERVAL_MS = 15000;

/** Pending transaction poll interval (10 seconds) */
export const PENDING_TX_POLL_INTERVAL_MS = 10000;

// ============================================
// Transaction Thresholds
// ============================================

/** Amount tolerance for matching transactions (USDC has 6 decimals) */
export const AMOUNT_MATCH_TOLERANCE = 0.001;

/** Maximum tip amount in USDC */
export const MAX_TIP_AMOUNT = 1000;

// ============================================
// Time Windows (minutes)
// ============================================

/** Window for duplicate pending tip detection */
export const DUPLICATE_TIP_WINDOW_MINUTES = 5;

/** Pending transaction expiry time */
export const PENDING_TX_EXPIRY_MINUTES = 30;

// ============================================
// Retry Configuration
// ============================================

/** Maximum retry attempts for failed API calls */
export const MAX_RETRY_ATTEMPTS = 3;

/** Base delay for exponential backoff (milliseconds) */
export const RETRY_BASE_DELAY_MS = 1000;

/** Maximum retry delay (milliseconds) */
export const MAX_RETRY_DELAY_MS = 10000;

// ============================================
// UI Configuration
// ============================================

/** Minimum input debounce delay (milliseconds) */
export const INPUT_DEBOUNCE_MS = 300;

/** Toast notification duration (milliseconds) */
export const TOAST_DURATION_MS = 5000;

/** Modal animation duration (milliseconds) */
export const MODAL_ANIMATION_MS = 200;

// ============================================
// Video Call Status
// ============================================

export const VIDEO_CALL_STATUS = {
  OUT_OF_MINUTES: 'OUT_OF_MINUTES',
  ALLOWED: 'ALLOWED',
} as const;

export type VideoCallStatus = (typeof VIDEO_CALL_STATUS)[keyof typeof VIDEO_CALL_STATUS];
